'use strict';

import $ from 'jquery';
import Mustache from 'mustache';
import utils from '../util';
import getToken from '../api/token';
import { getShops } from '../api/shops';
import { getUser } from '../api/users';
import Promise from 'bluebird';
import { inputFilteringEvents } from '../util/form';

export default async function (renderNow) {
	const $window = $(window);
	const $document = $(document);
	const $html = $('html');
	const $productForm = $('.v4-product-card form');
	const $clickAndCollect = $('.v4-product-click-and-collect');
	const template = $('#template-click-and-collect').html();

	const templateData = {
		reservation: {},
		product: {},
		errors: {},
		geoLocation: {},
		loaders: {},
		stores: [],
		cities: [],
		hasStores: false,
		selectFirstOption: false,
		disableCc: false,
		disableCcTitle: '',
		disableCcText: '',
		formatPrice: function () {
			return function (text, render) {
				return formatPrice(render(text));
			};
		},
	};

	let loggedIn = 0;

	const shipmentTypes = {
		posti: {
			default: 7.9,
			club: 5.9,
		},
		kotiintoimitus: {
			default: 11.9,
			club: 9.9,
		},
		special: {
			default: 49.9,
			club: 24.9,
		},
		nouto: {
			default: 0,
			club: 0,
		},
	};

	const customShipmentTypes = [];

	function isValidDateObject(date) {
		return date instanceof Date && !isNaN(date)
	}

	function isValidSaleCampaignProduct(saleCampaignIds, productCampaignIds) {
		const productsCampaigns = productCampaignIds?.toString().split(',') || [];
		return productsCampaigns.some(productCampaign => saleCampaignIds.includes(productCampaign))
	}

	const isLoggedIn = window.user?.loggedIn === true;
	const productData = $productForm.data();
	templateData.retailPrice = parseFloat(productData.retailPrice);

	// Overrides default C&P shipment types. If these are not set, defaults will be used.
	// Currently only used for SUP boards - they use slightly different "kotiintoimitus" style shipment type and the price is different.
	// I.e. it's a "semi-special" shipment type.
	const freeDelivery = window.freeDeliveryForCp || false;
	if (window.ccShipmentTypes && (window.ccShipmentTypes !== 'false')) {
		try {
			const ccShipmentTypes = window.ccShipmentTypes;
			if (Array.isArray(ccShipmentTypes)) {
				for (const shipmentType of ccShipmentTypes) {
					customShipmentTypes.push(shipmentType);
					shipmentTypes[shipmentType.id] = {
						default: shipmentType.default,
						club: shipmentType.club,
					};
				}

				if(freeDelivery) {
					for (const method of freeDelivery.methods) {
						// customShipmentTypes.push(shipmentType);
						shipmentTypes[method] = {
							// default: shipmentType.default,
							club: 0,
						};
					}
					shipmentTypes['posti'] = {
						club: 0,
					};
				}

			}
		} catch (error) {
			// Could not parse shipment types, will use defaults.
		}
	}

	const campaignSaleData = await getCNPCampaigns();
	let hasActiveClickAndCollectSale = false;
	let clubSale = false;
	let plussaSale = false;
	let brandSale = false;
	let normalPriceSale = false;
	let validCNPCampaigns = [];

	/**
 * Find the best sale campaign for the given product, based on salePercentage.
 *
 * @param {Object[]} campaigns The campaigns to check, as returned by getCNPCampaigns()
 * @param {string} [campaignType] Check only campaigns of this type. Optional.
 * @returns {Object} A single campaign object with the highest salePercentage, or null if no valid campaign was found.
 */
	function findBestSaleCampaign(campaigns, campaignType) {
		if (campaignType) return findBestSaleCampaign(campaigns.filter(campaign => campaign.campaignType === campaignType));

		return campaigns.reduce((bestCampaign, currentCampaign) => {
			return (!bestCampaign || currentCampaign.salePercentage > bestCampaign.salePercentage) ? currentCampaign : bestCampaign;
		}, null);
	}

	function updateCampaigns() {
		// Toggle visibility of sale info boxes
		hasActiveClickAndCollectSale = false;
		clubSale = false;
		plussaSale = false;
		brandSale = false;
		normalPriceSale = false;
		validCNPCampaigns = [];

		// Different campaigns (plussa, club/loggedIn, and brand) can be scheduled in the database table cnp_campaigns.

		validCNPCampaigns = campaignSaleData.filter(sale => campaignIsValidForProduct(sale, productData));

		hasActiveClickAndCollectSale = validCNPCampaigns.length > 0 && !productData.campaignDisabledForCc;
		clubSale = validCNPCampaigns.some(campaign => campaign.campaignType === 'club');
		plussaSale = validCNPCampaigns.some(campaign => campaign.campaignType === 'plussa');
		brandSale = validCNPCampaigns.some(campaign => campaign.campaignType === 'brand');
		normalPriceSale = validCNPCampaigns.some(campaign => campaign.campaignType === 'fromNormalPrice');

		//const bestValidCampaign = findBestSaleCampaign(validCNPCampaigns);
		// const bestSalePercentage = bestValidCampaign?.salePercentage || 0;
		// const campaignSaleMultiplier = 1.0 - bestSalePercentage;

		if (hasActiveClickAndCollectSale) {
			// Pick best sale campaign of each sale type and prepare it for the template
			// These can be used in the template like this:
			// {{#saleCampaigns.club}}Get a discount of {{salePercentage}}% with your club membership!{{/saleCampaigns.club}}
			const saleTypes = ['club', 'plussa', 'brand', 'fromNormalPrice'];

			templateData.saleCampaigns = [];
			saleTypes.forEach(saleType => {
				// Reset sale campaign data
				templateData[`show${saleType.charAt(0).toUpperCase() + saleType.slice(1)}SaleInfo`] = false;
			});

			saleTypes.forEach(saleType => {
				const bestSaleCampaign = findBestSaleCampaign(validCNPCampaigns, saleType);
				if (bestSaleCampaign) {
					const retailPrice = parseFloat(productData.retailPrice);
					templateData.saleCampaigns[saleType] = {
						salePercentage: (bestSaleCampaign.salePercentage * 100).toFixed(0),
						retailPrice: retailPrice ? String(retailPrice.toFixed(2)).replace('.', ',') : false,
						saleBannerText: bestSaleCampaign.saleBannerText || false,
					};

					templateData[`show${saleType.charAt(0).toUpperCase() + saleType.slice(1)}SaleInfo`] = true;
				}
			});
		}
	}

	templateData.isLoggedIn = isLoggedIn;

	if ($productForm.length) {
		const {
			disableCc,
			sellingStarts,
			sellingEnabled,
			campaignBanner,
			vmChainCampaign,
			freeDeliveryCp
		} = $productForm.data();
		if (sellingStarts) {
			templateData.sellingStarts = $productForm.data('selling-starts');
		}
		if (disableCc) {
			templateData.disableCc = true;
			if (campaignBanner) {
				templateData.campaignBanner = campaignBanner;
			}
		}

		if(freeDeliveryCp) {
			templateData.freeDeliveryCp = true;

		}

		const ccDisableStart = new Date('2024/04/08 07:00:00');
		const ccDisableEnd = new Date('2024/04/16 02:59:59');

		templateData.vmEnableCp = true;

		if (ccDisableStart < new Date() && ccDisableEnd > new Date()) {
			templateData.vmProduct = $('.v4-product').hasClass('vm-product');
			templateData.vmEnableCp = $('.v4-product').hasClass('vm-product') && $productForm.data('sellingEnabled') === true;
			//const campaignIds = $productForm.not('.extra-sale-product').data('campaign-ids')+'' || null;
			//templateData.vmProduct = campaignIds ? (campaignIds.indexOf('0373') !== -1 || campaignIds.indexOf('0374') !== -1) : false;
		}

		if ($productForm.data('enable-cp-for-special-delivery')) {
			templateData.enableCCforSpecialDelivery = true;
		}

		templateData.vmChainCampaign = vmChainCampaign;

		if (!sellingEnabled) {
			templateData.sellingDisabled = true;
		}
		if (templateData.disableCampaignCc && !templateData.sellingDisabled) {
			templateData.sale = true;
		}

		[
			'campaignName',
			'sellingStarts',
			'campaignPrice',
			'campaignDay',
			'disableCcTitle',
			'disableCcText',
			'disableCc',
		].forEach((prop) => {
			if (productData[prop]) {
				templateData[prop] = productData[prop];
			}
		});
		/*
		if (campaignName) {
			templateData.campaignName = campaignName;
		}
		if (sellingStarts) {
			templateData.sellingStarts = sellingStarts;
		}
		if (campaignPrice) {
			templateData.campaignPrice = campaignPrice;
		}
		if (campaignDay) {
			templateData.campaignDay = campaignDay;
		}*/
	}

	let shopsLoaded = false;
	let userInfo = null;
	let shops = {};

	//const shops = $clickAndCollect.data('shops') || {};
	const storeBalances = {};

	let isActived = false;
	let jqXHR;

	clickAndCollectEvents();
	productFormEvents();

	if (renderNow) {
		templateData.selectFirstOption = true;
		toggleReservationForm(false);
		updateProductData();
		resetErrors();
		getStoreBalances(true);
	}

	$(window).on('popstate', (e) => {
		if ($clickAndCollect.hasClass('reservation-form-visible')) {
			toggleReservationForm(false);
		} else {
			closeClickAndCollect();
		}
	});

	/**
	 * clickAndCollectEvents
	 */
	function clickAndCollectEvents() {
		if (!renderNow) {
			$clickAndCollect.appendTo('#intersport-page');
		}

		$clickAndCollect
			.on('click', '.product-click-and-collect-close', closeClickAndCollect)
			.on(
				'click',
				'.click-and-collect-stores-order-by-location-button',
				function () {
					if (templateData.geoLocation.enabled) {
						templateData.geoLocation.enabled = false;

						renderData();
					} else {
						resetErrors();

						getgeoLocation().always(function () {
							renderData();
						});
					}
				}
			)
			.on('change', '#click-and-collect-cities', function () {
				templateData.selectedCity = $(this).val();

				resetErrors();
				updateStoresData();
				renderData();
			})
			.on('click', '.reserve-product-button', function () {
				const reservationData = $(this)
					.closest('.click-and-collect-stores-list-item')
					.data();
				const reservationDataUpdated = updateReservationData(
					reservationData.storeId,
					reservationData.storePrice,
					'collect'
				);
				if (reservationDataUpdated) {
					renderData();
					toggleReservationForm(true);
				} else {
					getStoreBalances(true);
				}
				shippingFee(false);
			})
			.on('click', '.order-product-button', function () {
				const reservationData = $(this)
					.closest('.click-and-collect-stores-list-item')
					.data();
				const reservationDataUpdated = updateReservationData(
					reservationData.storeId,
					reservationData.storePrice,
					'order'
				);

				if (reservationDataUpdated) {
					renderData();
					toggleReservationForm(true, true);
				} else {
					getStoreBalances(true);
				}
				shippingFee(true);
			})
			.on('click', '.click-and-collect-reservation-close', function () {
				toggleReservationForm(false);
			})
			.on(
				'keyup invalid',
				'.click-and-collect-reservation-form input',
				function () {
					const $this = $(this);
					$this.toggleClass('invalid', $this.is(':invalid'));
				}
			)
			.on('submit', '.click-and-collect-reservation-form', function (e) {
				processReservationForm(e);

			})
			.on(
				'change',
				'.click-and-collect-reservation-form input[name="shipping"]',
				function () {
					setOnlinePayment();
					if (parseInt($(this).val()) === 1) {
						setShipping();
						$('.shipping-fee').removeClass('hidden');
						if (hasActiveClickAndCollectSale) {
							$('.plussa-campaign-info').removeClass('hidden');
						}
					} else {
						$('.shipping-fee').addClass('hidden');
						setCollecting();
						if (hasActiveClickAndCollectSale) {
							$('.plussa-campaign-info').addClass('hidden');
						}
					}
					updateCampaigns();
					if (hasActiveClickAndCollectSale) {
						setCampaignSale();
					}
				}
			)
			.on(
				'change',
				'.click-and-collect-reservation-form input[name="shipment_type"]',
				function () {
					deliveryFee();
					const shipmentType = $('input[name="shipment_type"]:checked').val();
					const price =
						shipmentType !== 'nouto'
							? parseFloat(
								templateData.reservation.shipmentFee[shipmentType]
							).toFixed(2)
							: 0;

					$('dd.shipping-fee').text(`${price}€`);
				}
			)
			.on(
				'change',
				'.click-and-collect-reservation-form input[name="online_payment"]',
				setOnlinePayment
			)
			.on('change', '.click-and-collect-reservation-form input[name="kplussa_number"]', function () {
				updateCampaigns();
				if (hasActiveClickAndCollectSale && plussaSale) {
					setCampaignSale();
				}
			});

		/*.on('change', '.click-and-collect-reservation-form input[name="shipping"]', function() {
				setOnlinePayment();
				if ($(this).val() == 1) {
					setShipping();
				} else {
					setCollecting();
				}
				if (hasActiveClickAndCollectSale) {
					setCampaignSale();
				}
			});*/

		// Close c&c by clicking outside it or outside the product form
		$document.on('click', function (e) {
			if (
				$clickAndCollect.hasClass('transition-done') &&
				!$(e.target).closest(
					'.v4-product-click-and-collect, .click-and-collect-stores-order-by-location-button, .reserve-product-button, .order-product-button, .product-colors, .product-sizes, .text-show-more'
				).length &&
				!renderNow
			) {
				closeClickAndCollect();
			}
		});

	}

	function shippingFee(active = false) {
		if (active) {
			$('.shipping-fee').removeClass('hidden');
			if (hasActiveClickAndCollectSale) {
				$('.plussa-campaign-info').removeClass('hidden');
			}
		} else {
			$('.shipping-fee').addClass('hidden');
			if (hasActiveClickAndCollectSale) {
				$('.plussa-campaign-info').addClass('hidden');
			}
		}
		if (hasActiveClickAndCollectSale) {
			setCampaignSale();
		}
	}

	function setShipping() {
		setRequiredFields(true);
		$('.click-and-collect-reservation-title').text('Vahvista tilaus');
		$('.shipping-disclaimer').removeClass('hidden');
		$('.click-and-collect-reservation-form .form-submit button').text('Tilaa');
		$(
			'.click-and-collect-reservation-form *[name="accepted_privacy_policy]'
		).prop('required', true);
		const $paymentInput = $('.click-and-collect-payment-method')
			.removeClass('hidden')
			.find('input[name="online_payment"]');
		if (!$paymentInput.is(':checked')) {
			$paymentInput.first().prop('checked', true);
		}
		setOnlinePayment();
	}

	function setOnlinePayment() {
		const paymentMethod = $('input[name=online_payment]:checked').val();
		if (templateData.reservation.order && paymentMethod) {
			$('input[name=stage-payment-provider]').prop('checked', false);
			$(`.payment-method-${paymentMethod}`).find('input').prop('checked', true);
		}
	}

	/**
	 * @function checkIfUserHasValidPlussaCard
	 * Makes a server-side validation of the plussa card number possibly entered by the user.
	 * @returns {boolean} true if user has a valid plussa card, false otherwise
	 */
	async function checkIfUserHasValidPlussaCard() {
		// Get plussa number value from the form
		const selector = '.click-and-collect-reservation-form input[name="kplussa_number"]';
		const plussaInput = document.querySelector(selector);
		if (!plussaInput) return false;

		let cardNumber = plussaInput.value;
		if (!cardNumber) return false;

		// Get plussa prefix from plussa input's data attribute
		const plussaPrefix = String(plussaInput.dataset.plussaPrefix);
		if (plussaPrefix && cardNumber && cardNumber.indexOf(plussaPrefix) !== 0) {
			cardNumber = plussaPrefix + cardNumber;
		}

		return await fetch('/stage-ajax/ccPlussaSale', {
			method: 'POST',
			headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', 'Accept': 'application/json' },
			body: `cardNumber=${cardNumber}`,
		}).then(response => response.json()).then(({ result }) => {
			return parseInt(result) === 1;
		});
	}

	/**
	 * @function setCampaignSale
	 * This function does 2 things:
	 * 1. Toggle the visibility of each sale campaign info box ("Liity klubiin ja saat 20% alennuksen").
	 *    - If the user has entered a valid plussa number, hide the plussa sale info box.
	 *    - If the user is logged in, hide the club sale info box.
	 * 2. Update the price of the product displayed above the form.
	 */
	async function setCampaignSale() {
		const $form = $('.click-and-collect-reservation-form');
		const shipping = $form.find('input[name="shipping"]').val();
		const orderType = shipping && parseInt(shipping) === 1 ? 'order' : 'collect';

		/**
		 * Step 1: Check which sales are active, and which info boxes should be shown.
		 */

		// Check plussa sale
		let userHasValidPlussaCard = false;
		if (plussaSale && orderType === 'order') {
			userHasValidPlussaCard = await checkIfUserHasValidPlussaCard();
		}
		// const plussaSalePriceIsActivated = plussaSale && userHasValidPlussaCard && orderType === 'order';
		const showPlussaSaleInfoBox = plussaSale && !userHasValidPlussaCard && orderType === 'order';

		// Check club sale
		// const clubSalePriceIsActivated = clubSale && userInfo && orderType === 'order';
		const showClubSaleInfoBox = clubSale && !userInfo && orderType === 'order';

		// Check brand sale
		// const brandSalePriceIsActivated = brandSale && orderType === 'order';
		const showBrandSaleInfoBox = brandSale && orderType === 'order';

		// From normal price sale
		// const fromNormalPriceSalePriceIsActivated = normalPriceSale && orderType === 'order';
		const showFromNormalPriceSaleInfoBox = normalPriceSale && orderType === 'order';

		// Toggle visibility of sale info boxes
		$('.cc-info-box.plussa-campaign-info').toggleClass('hidden', !showPlussaSaleInfoBox);
		$('.cc-info-box.sale-login').toggleClass('hidden', !showClubSaleInfoBox);
		$('.cc-info-box.brand-sale-info').toggleClass('hidden', !showBrandSaleInfoBox);
		$('.cc-info-box.from-normal-price-sale-info').toggleClass('hidden', !showFromNormalPriceSaleInfoBox);

		// Toggle visibility of plussa card validation
		$('.plussa-card-validated').toggleClass('hidden', !userHasValidPlussaCard);

		/**
		 * Step 2: Calculate the currently active price of the product and update it
		 */



		// Calculate current active price for user
		/*
		const bestActiveSalePercentage = Math.max(
			plussaSalePriceIsActivated ? templateData.saleCampaigns.plussa?.salePercentage || 0 : 0,
			clubSalePriceIsActivated ? templateData.saleCampaigns.club?.salePercentage || 0 : 0,
			brandSalePriceIsActivated ? templateData.saleCampaigns.brand?.salePercentage || 0 : 0,
			fromNormalPriceSalePriceIsActivated ? templateData.saleCampaigns.fromNormalPrice?.salePercentage || 0 : 0
		); */
		const bestCampaigns = findBestSaleCampaign(validCNPCampaigns);

		const bestActiveSalePercentage = ((bestCampaigns?.salePercentage || 0) * 100).toFixed(0);
		const originalPrice = templateData.reservation.items[0].price;

		const salePrice = parseFloat((bestCampaigns.campaignType === 'fromNormalPrice' ? templateData.retailPrice : templateData.reservation.items[0].price) * (1 - bestActiveSalePercentage / 100)).toFixed(2);
		templateData.salePrice = salePrice;
		const originalPriceFormatted = parseFloat(originalPrice).toFixed(2);

		// Update price text
		if (originalPrice !== salePrice) {
			const priceText = `<span style="text-decoration: line-through;">${originalPriceFormatted} €</span> <span style="color: #e60b0b;">${salePrice} €</span>`;
			// Update plussa card validation texts
			const plussaCampaignIsBest = bestActiveSalePercentage === templateData.saleCampaigns.plussa?.salePercentage;
			if (plussaCampaignIsBest) {
				$('.plussa-card-validated .price-info').html(`Tuotteen hinta: ${priceText}`);
			} else {
				$('.click-and-collect-reservation dl dt:contains("Hinta") + dd').html(priceText);
			}
		}
		else {
			$('.click-and-collect-reservation dl dt:contains("Hinta") + dd').html(originalPriceFormatted + ' €');
		}
	}

	function setCollecting() {
		setRequiredFields(false);
		$('.click-and-collect-reservation-title').text('Vahvista varaus');
		$('.click-and-collect-reservation-form .form-submit button').text('Varaa');
		$(
			'.click-and-collect-reservation-form *[name="accepted_privacy_policy]'
		).prop('required', false);
		$('.shipping-disclaimer').addClass('hidden');
		$('.click-and-collect-payment-method').addClass('hidden');
	}

	function setRequiredFields(isRequired) {
		const $requiredFields = $('.click-and-collect-reservation-form').find(
			'.required-for-shipping'
		);
		$requiredFields.prop('required', isRequired);
		$requiredFields.each(function () {
			const $label = $(this).closest('.form-input').find('label');
			const labelText = isRequired
				? $label.text().replace(' *', '') + ' *'
				: $label.text().replace(' *', '');
			$label.text(labelText);
		});
	}

	const paymentHtml = {};

	function showPaymentForm(shopId) {
		if (!paymentHtml[shopId]) {
			let url = '/stage-ajax/getPaymentForm';
			if (shopId) {
				url += '?merchantId=' + shopId;
			}
			getToken()
				.then((token) => Promise.resolve($.post(url, { token })))
				.then((markup) => injectPayment(shopId, markup));
		} else {
			injectPayment(shopId);
		}
	}

	function injectPayment(shopId, markup) {
		if (markup !== undefined) {
			paymentHtml[shopId] = markup;
		}
		$('.click-and-collect-payment-form').remove();
		if (paymentHtml[shopId]) {
			$('.click-and-collect-payment-method')
				.append(paymentHtml[shopId])
				.find('input[name="stage-payment-provider"]')
				.first()
				.prop('checked', true);
			$('.click-and-collect-payment-form').addClass('hidden');
		}
	}

	function openClickAndCollect() {
		if ($productForm.find('[name="ean"]:checked').length) {
			storeScrollPosition($window);
			toggleClickAndCollect(true);
			if (!isActived) {
				isActived = true;
				$productForm.find('[name="ean"]:checked').trigger('change');
				getgeoLocation().always(function () {
					renderData();
				});
			} else if (window.user && window.user.loggedIn && !userInfo) {
				// User has logged in via ajax, get full user info
				const userPromise =
					userInfo === null
						? getUser('me').then((res) => {
							if (res.user) {
								userInfo = res.user;
							}
						})
						: Promise.resolve();

				Promise.all([userPromise]).then(() => {
					if (userInfo) {
						renderData();

						// Update user info for form
						const $form = $clickAndCollect.find(
							'.click-and-collect-reservation-form'
						);
						updateUserInfo($form);

						// Show shipping fee
						shippingFee(true);
					}
				});
			}
			if (typeof history !== 'undefined') {
				// push empty history entry to allow back button to close the panel
				history.pushState(null, '', '');
			}
			return true;
		}
		return false;
	}

	function closeClickAndCollect() {
		toggleClickAndCollect(false);
		restoreScrollPosition($window);
	}

	/**
	 * productFormEvents
	 */
	function productFormEvents() {
		$productForm
			.on('click', '.click-and-collect-button:not(.disabled)', function (e) {
				e.preventDefault();
				if ($productForm.find('[name="ean"]:checked').length) {
					//window.location.hash = 'saatavuus';
					openClickAndCollect();
				}
			})
			.on('change', '[name="color"]', function () {
				if (isActived) {
					toggleReservationForm(false);
					updateProductData();
					getStoreBalances(true);
					resetErrors();
				}
			})
			.on('change', '[name="ean"]', function () {
				if (isActived) {
					toggleReservationForm(false);
					updateProductData();
					getStoreBalances(true);
					resetErrors();
				} else {
					//updateProductData();
					//getStoreBalances(true);
				}
			})
			.on('click', '[data-toggle="modal"]', function () {
				toggleClickAndCollect(false);
			});
	}

	function infoTextAccordion() {
		const $showMore = $('.text-show-more');
		$showMore.on('click', 'a', (e) => {
			e.preventDefault();
			const $toggleLink = $(e.target);
			const $linkContainer = $toggleLink.parent();
			const show = $toggleLink.hasClass('show-text');

			if (show) {
				$linkContainer.find('p').show();
				$linkContainer.find('.show-text').hide();
				$linkContainer.find('.close-text').show();
			} else {
				$linkContainer.find('p').hide();
				$linkContainer.find('.show-text').show();
				$linkContainer.find('.close-text').hide();
			}
		});
	}

	/**
	 * getStoreBalances
	 *
	 * @param {Boolean} updateDataAndRender
	 *
	 * @return {Promise}
	 */
	function getStoreBalances(updateDataAndRender) {
		const ttl = 60;
		let colorBalances = storeBalances[templateData.product.sapTitlenumber]
			? storeBalances[templateData.product.sapTitlenumber][
				templateData.product.colorCode
			]
			: null;

		if (
			!colorBalances ||
			(colorBalances.stores && !colorBalances.stores.length) ||
			getTimestamp() - colorBalances.timestamp > ttl
		) {
			if (getLoader('stores') && isActived) {
				jqXHR?.abort();
			}

			setLoader('stores', true);

			const shopPromise = !shopsLoaded
				? getShops().then((res) => {
					shops = res.shops;
					shopsLoaded = true;
				})
				: Promise.resolve();

			const userPromise =
				userInfo === null
					? getUser('me').then((res) => {
						if (res.user) {
							userInfo = res.user;
						}
					})
					: Promise.resolve();

			Promise.all([shopPromise, userPromise]).then(() => {
				jqXHR = $.ajax({
					cache: true,
					data: {
						color: templateData.product.colorCode,
						sap_titlenumber: templateData.product.sapTitlenumber,
					},
					dataType: 'json',
					method: 'get',
					timeout: 30000,
					url: '/stage-ajax/storeBalances/',
				})
					.done(function (response, status, xhr) {
						if (response.items) {
							processStoreBalances(
								response.items,
								response.colorCode,
								response.sapTitlenumber
							);
						} else {
							handleStoreBalanceErrors(xhr);
						}

						if (response.disableCC) {
							//templateData.disableCC = true;
							//templateData.disableCCTitle = response.disableCCTitle;
							//templateData.disableCCText = response.disableCCText;
						}

						if (updateDataAndRender) {
							updateStoresData();
							renderData();
						}
					})
					.fail(handleStoreBalanceErrors)
					.always(function () {
						setLoader('stores', false);
					});
			});
			colorBalances = jqXHR;
		} else if (updateDataAndRender) {
			updateStoresData();
			renderData();
		}

		return $.when(colorBalances);
	}

	/**
	 * processStoreBalances
	 *
	 * @param {Array} stores
	 * @param {String} colorCode
	 */
	function processStoreBalances(stores, colorCode, sapTitlenumber) {
		storeBalances[sapTitlenumber] = {};
		storeBalances[sapTitlenumber][colorCode] = {
			timestamp: getTimestamp(),
		};

		storeBalances[sapTitlenumber][colorCode].stores = $.map(
			stores,
			function (store) {
				if (shops[store.shop]) {
					if (typeof store.storeData === 'undefined') {
						store.id = store.shop;
						delete store.shop;
						store.storeData = shops[store.id] || {};
					}
					return store;
				}
			}
		).sort(function (a, b) {
			if (a.storeData.city === b.storeData.city) {
				return a.storeData.name < b.storeData.name
					? -1
					: a.storeData.name > b.storeData.name
						? 1
						: 0;
			}
			return a.storeData.city < b.storeData.city
				? -1
				: a.storeData.city > b.storeData.city
					? 1
					: 0;
		});
	}

	/**
	 * handleStoreBalanceErrors
	 *
	 * @param {Object} xhr
	 */
	function handleStoreBalanceErrors(xhr) {
		const response =
			xhr && xhr.statusText !== 'abort' ? xhr.responseJSON : false;

		if (response) {
			storeBalances[response.sapTitlenumber] = {};
			storeBalances[response.sapTitlenumber][response.colorCode] = {
				error: response.error,
			};
		}
	}

	/**
	 * updateProductData
	 */
	function updateProductData() {
		const colorVisible = $productForm.find('.product-colors').data('visible');
		const $color = $productForm.find('[name="color"]:checked, [type="hidden"][name*="color"][data-page-variant="true"]');
		const sizeVisible = $productForm.find('.product-sizes').data('visible');
		const $size = $productForm.find('[name="ean"]:checked');
		const sapTitlenumber =
			$size.data('sap-titlenumber') || $productForm.data('sapTitlenumber');
		const flex = $size.data('ice-hockey-flex') || null;
		const hand = $size.data('hand') || null;

		templateData.product = {
			color: parseInt(colorVisible) === 1 ? $color.data('name') : '',
			colorCode: $color.val(),
			ean: $size.closest(
				'.product-sizes-list[data-color="' + $color.val() + '"]'
			).length
				? $size.val()
				: '',
			name:
				$productForm.data('brandName') + ' ' + $productForm.data('productName'),
			sapTitlenumber: sapTitlenumber,
			size: parseInt(sizeVisible) === 1 ? $size.data('name') : '',
			image: $color
				.closest('.product-colors-list-item')
				.find('img')
				.attr('src')
				.replace('c=system_150', 'c=system_1024x'),
			canShip: !$productForm.data('specialDelivery') || customShipmentTypes.length,
			specialDelivery: $productForm.data('enable-cp-for-special-delivery'), //enable-cp-for-special-delivery
			isIceHockeyStick: !!flex,
			flex: flex,
			hand: hand,
		};

		templateData.stores = [];
		templateData.cities = [];
		templateData.hasStores = false;
	}

	/**
	 * updateStoresData
	 */
	function updateStoresData() {
		const colorBalances = storeBalances[templateData.product.sapTitlenumber]
			? storeBalances[templateData.product.sapTitlenumber][templateData.product.colorCode]
			: null;

		if (colorBalances) {
			if (!colorBalances.error) {
				const uniqueCities = [];

				templateData.cities = [];

				templateData.stores = $.map(colorBalances.stores, function (store) {
					const storeBalance = store.balances.filter(function (balanceItem) {
						return (
							!balanceItem.ccDisabled &&
							templateData.product &&
							templateData.product.ean === balanceItem.ean &&
							balanceItem.balance > 0
						);
					});

					store.canShip =
						(store.hasOnlinePayment || store.storeData.prepayment) &&
						(templateData.product.canShip ||
							templateData.product
								.specialDelivery) /*&& parseFloat(store.price) >= 50*/;
					store.specialDelivery = templateData.product.specialDelivery;

					if (storeBalance.length) {
						if (uniqueCities.indexOf(store.storeData.city) === -1) {
							uniqueCities.push(store.storeData.city);
							templateData.cities.push({ name: store.storeData.city });
						}

						const lowBalanceThreshold = templateData.disableCampaignCc ? 3 : 2;
						storeBalance[0].hasLowBalance =
							storeBalance[0].balance <= lowBalanceThreshold;
						const item = $.extend({}, store, {
							balanceData: storeBalance[0],
						});
						if (item.balanceData.forceEnableCc) {
							delete item.disableCc;
						}
						return item;
					}
				});

				// Select first of the options
				if (templateData.selectFirstOption && templateData.cities.length > 0) {
					templateData.selectedCity = templateData.cities[0].name;
					templateData.selectFirstOption = false;
				}

				const foundInStores = templateData.stores.length;
				const foundInStoresText = `Tuote on saatavilla <a href="#" class="click-and-collect-button">${foundInStores} kaupassa.</a> Katso kauppasaatavuus nähdäksesi tarkemmat tiedot.`;
				$('.product-available-in-stores').find('span').html(foundInStoresText);

				templateData.hasStores = !!templateData.stores.length;
			} else {
				setError('stores', colorBalances.error);
			}
		}
	}

	/**
	 * filterStoresbyCity
	 *
	 * @param {String} [city]
	 */
	function filterStoresbyCity(city = templateData.selectedCity) {
		if (city) {
			const cityStores = templateData.stores.filter(function (store) {
				return !city || city === store.storeData.city;
			});

			$.each(templateData.cities, function (i, cityItem) {
				if (city === cityItem.name) {
					cityItem.selected = true;
					return false;
				}
			});

			if (cityStores.length) {
				templateData.stores = cityStores;
				setError('cities', false);
			} else {
				setError('cities', true);
			}
		}
	}

	/**
	 * getgeoLocation
	 *
	 * @return {Promise}
	 */
	function getgeoLocation() {
		const dfd = $.Deferred();

		setLoader('geoLocation', true);

		navigator.geolocation.getCurrentPosition(dfd.resolve, dfd.reject, {
			enableHighAccuracy: true,
			timeout: 5000,
			maximumAge: 60000,
		});

		dfd
			.done(function (position) {
				if (position) {
					templateData.geoLocation.enabled = true;
					templateData.geoLocation.lat = position.coords.latitude;
					templateData.geoLocation.lon = position.coords.longitude;
				} else {
					handleGeoLocationErrors(position);
				}
			})
			.fail(handleGeoLocationErrors)
			.always(function () {
				setLoader('geoLocation', false);
			});

		return dfd.promise();
	}

	/**
	 * handleGeoLocationErrors
	 *
	 * @param {Object} error
	 */
	function handleGeoLocationErrors(error) {
		$('.click-and-collect-stores-order-by-location-button')
			.addClass('hidden')
			.hide();
		/*if (error.code === 1) {
			setError('geoLocationBlockedByUser', true);
		} else {
			setError('geoLocation', true);
		}*/
	}

	/**
	 * orderStoresByLocation
	 *
	 * @param {Number} [lat]
	 * @param {Number} [lon]
	 */
	function orderStoresByLocation(
		lat = templateData.geoLocation.lat,
		lon = templateData.geoLocation.lon
	) {
		if (templateData.geoLocation.enabled) {
			$.each(templateData.stores, function (i, store) {
				store.distance = Math.round(
					calculateDistance(
						lat,
						lon,
						Number(store.storeData.lat),
						Number(store.storeData.long)
					)
				);
			});

			templateData.stores = templateData.stores.sort(function (a, b) {
				return a.distance < b.distance ? -1 : a.distance > b.distance ? 1 : 0;
			});
		}
	}

	/**
	 * updateReservationData
	 *
	 * @param {String} storeId
	 * @param {Number} price
	 *
	 * @return {Boolean} allowReservation
	 */
	function updateReservationData(storeId, price, type) {
		const isValidReservation = templateData.stores.some(function (store) {
			return store.id === storeId && price > 0 && (!store.disableCc || templateData.vmEnableCp);
		});

		const store = templateData.stores.find((store) => store.id === storeId);

		if (isValidReservation) {
			templateData.reservation = {
				items: [
					{
						amount: 1,
						price: price,
						ean: templateData.product.ean,
						name: templateData.product.name,
						color: templateData.product.color,
						size: templateData.product.size,
						image: templateData.product.image,
						isIceHockeyStick: templateData.product.isIceHockeyStick,
						flex: templateData.product.flex,
						hand: templateData.product.hand,
					},
				],
				store: storeId && shops[storeId] ? shops[storeId].name : '',
				storeId: storeId.charAt(0) === 't' ? storeId.substring(1) : storeId,
				extranet_users_uuid: '',
				shop: store.storeData,
				hasOnlinePayment:
					store && store.hasOnlinePayment && store.storeData.online_payment,
				canShip: store.canShip,
				specialDelivery: store.specialDelivery,
			};
			updateCampaigns();

			if (typeof type !== 'undefined') {
				templateData.reservation.shop.termsLink =
					templateData.reservation.shop.termsLink.indexOf('?type') === -1
						? `${templateData.reservation.shop.termsLink}?type=${type}`
						: templateData.reservation.shop.termsLink.replace(/type=(.*)/g, `type=${type}`);
				templateData.reservation.shop.dataProtectionLink =
					templateData.reservation.shop.dataProtectionLink.indexOf('?type') === -1
						? `${templateData.reservation.shop.dataProtectionLink}?type=${type}`
						: templateData.reservation.shop.dataProtectionLink.replace(/type=(.*)/g, `type=${type}`);
				templateData.reservation[type] = true;
			}
		}

		return isValidReservation;
	}

	function updateUserInfo($form) {
		if (userInfo) {
			const plussaPrefix = String($form.find('input[name="kplussa_number"]').data('plussa-prefix'));
			const usersPlussaNumber = userInfo.kplussa_number;

			// if userInfo contains kplussa_number remove plussaPrefix from the beginning if it's included
			if (usersPlussaNumber && plussaPrefix && usersPlussaNumber.indexOf(plussaPrefix) === 0) {
				// remove plussaPrefix from the beginning
				const plussaWithoutPrefix = usersPlussaNumber.slice(plussaPrefix.length, usersPlussaNumber.length)
				userInfo.kplussa_number = plussaWithoutPrefix;
			}

			$form.serializeArray().forEach((field) => {
				let { name } = field;
				if (name === 'extranet_users_uuid') {
					name = 'uuid';
				}
				if (userInfo[field.name]) {
					$form.find(`*[name="${field.name}"]`).val(userInfo[name]);
				}
			});
		}
	}

	/**
	 * toggleReservationForm
	 * @param {Boolean} showForm
	 */
	function toggleReservationForm(showForm, shipping) {
		if (typeof showForm !== 'undefined') {
			const $scrollArea = $clickAndCollect.find(
				'.click-and-collect-scroll-area'
			);

			if (showForm) {
				storeScrollPosition($scrollArea);
				$clickAndCollect.addClass('reservation-form-visible');

				const $form = $clickAndCollect.find(
					'.click-and-collect-reservation-form'
				);
				updateUserInfo($form);

				if (templateData.reservation.hasOnlinePayment) {
					showPaymentForm(templateData.reservation.storeId);
				} else {
					$('.click-and-collect-payment-form').remove();
				}

				$scrollArea.scrollTop(0);
				if (typeof history !== 'undefined') {
					history.pushState(null, '', '');
				}
			} else {
				$clickAndCollect.removeClass('reservation-form-visible');
				restoreScrollPosition($scrollArea);
			}
		}
	}

	/**
	 * processReservationForm
	 *
	 * @param {Object} e
	 */
	function processReservationForm(e) {
		const $form = $clickAndCollect.find('.click-and-collect-reservation-form');
		const onlinePayment =
			parseInt($form.find('input[name="stage_payment"]').val()) === 1;
		const $plussaInput = $form.find('input[name="kplussa_number"]');
		const plussaPrefix = String($plussaInput.data('plussa-prefix'));

		if (!onlinePayment) {
			e.preventDefault();
		} else {
			return;
		}

		const $token = $form.find('input[name$="token"]');
		const $submit = $form.find('button[type="submit"]');
		const formErrorMessage = $form.data('formErrorText');

		$submit.prop('disabled', true);

		clearReservationFormMessages();
		addReservationFormLoader();

		if ($token.val()) {
			loggedIn = userInfo ? 1 : 0;
			const data = $.extend(
				{ items: templateData.reservation.items, loggedIn },
				$form.serializeObject()
			);

			// if data containes kplussa_number add plussaPrefix to the beginning if it's missing
			if (data.kplussa_number && data.kplussa_number.indexOf(plussaPrefix) !== 0) {
				data.kplussa_number = plussaPrefix + data.kplussa_number;
			}

			$.ajax({
				data,
				dataType: 'json',
				method: 'POST',
				timeout: 30000,
				url: '/stage-ajax/clickAndCollect/',
			})
				.done(function (response) {
					if (response && response.result === 1) {
						if (
							Object.prototype.hasOwnProperty.call(
								templateData.reservation,
								'store'
							)
						) {
							let storeName = templateData.reservation.store.trim();
							window.dataLayer.push({
								event: 'cncOrder',
								store: storeName,
							});
						}

						if (response.checkout) {
							$form.attr('action', response.checkout);
							$form.find('input[name="stage_payment"]').val('1');
							updateFormToken().then(() => $form.submit());
						} else {
							templateData.reservation.done = true;
							if (response.shipping) {
								templateData.reservation.shipping = true;
							}

							if (templateData.salePrice) {
								// There's a salePrice (club sale, plussa sale or brand sale). Update item price according to that.
								templateData.reservation.items[0].price = templateData.salePrice;
							}

							renderData();
							toggleReservationForm(true);
						}
					} else if (response && response.reason) {
						addReservationFormMessage(response.reason, true);
					} else {
						addReservationFormMessage(formErrorMessage, true);
					}
				})
				.fail(function (xhr) {
					addReservationFormMessage(formErrorMessage, true);
				})
				.always(function (response) {
					if (!response.checkout) {
						removeReservationFormLoader();
						$form.find('input[name$="token"]').val('');
						$submit.prop('disabled', false);
					}
				});
		} else {
			updateFormToken($form);
		}
	}

	/**
	 * setLoader
	 *
	 * @param {String} name
	 * @param {Boolean} state
	 */
	function setLoader(name, state) {
		if (name && typeof state !== 'undefined') {
			if (state) {
				templateData.loaders[name] = true;
			} else {
				delete templateData.loaders[name];
			}

			$clickAndCollect.toggleClass(
				'is-loading',
				!!Object.keys(templateData.loaders).length
			);
		}
	}

	/**
	 * getLoader
	 *
	 * @param {String} name
	 *
	 * @return {Boolean}
	 */
	function getLoader(name) {
		return templateData.loaders[name] || false;
	}

	/**
	 * addFormMessage
	 *
	 * @param {String}  msg
	 * @param {Boolean} isError
	 */
	function addReservationFormMessage(msg, isError) {
		clearReservationFormMessages();

		$('<div>', {
			class: 'click-and-collect-info-block' + (isError ? ' is-error' : ''),
			text: msg,
		}).appendTo(
			$clickAndCollect.find(
				'#click-and-collect-reservation-form-alert-container'
			)
		);
	}

	/**
	 * clearReservationFormMessages
	 */
	function clearReservationFormMessages() {
		$clickAndCollect
			.find('#click-and-collect-reservation-form-alert-container')
			.find('.click-and-collect-info-block')
			.remove();
	}

	/**
	 * Add spinner loader to the page
	 */
	function addReservationFormLoader() {
		removeReservationFormLoader();

		$('<div>', { class: 'click-and-collect-loader' })
			.append($('<div>', { class: 'spinner-loader-circle' }))
			.append(
				$('<div>', { class: 'spinner-loader-circle spinner-loader-circle2' })
			)
			.append(
				$('<div>', { class: 'spinner-loader-circle spinner-loader-circle3' })
			)
			.append(
				$('<div>', { class: 'spinner-loader-circle spinner-loader-circle4' })
			)
			.append(
				$('<div>', { class: 'spinner-loader-circle spinner-loader-circle5' })
			)
			.append(
				$('<div>', { class: 'spinner-loader-circle spinner-loader-circle6' })
			)
			.append(
				$('<div>', { class: 'spinner-loader-circle spinner-loader-circle7' })
			)
			.append(
				$('<div>', { class: 'spinner-loader-circle spinner-loader-circle8' })
			)
			.append(
				$('<div>', { class: 'spinner-loader-circle spinner-loader-circle9' })
			)
			.append(
				$('<div>', { class: 'spinner-loader-circle spinner-loader-circle10' })
			)
			.append(
				$('<div>', { class: 'spinner-loader-circle spinner-loader-circle11' })
			)
			.append(
				$('<div>', { class: 'spinner-loader-circle spinner-loader-circle12' })
			)
			.appendTo(
				$clickAndCollect.find(
					'#click-and-collect-reservation-form-alert-container'
				)
			);
	}

	/**
	 * Add Remove loader to the page
	 */
	function removeReservationFormLoader() {
		$clickAndCollect
			.find('#click-and-collect-reservation-form-alert-container')
			.find('.click-and-collect-loader')
			.remove();
	}

	/**
	 * setError
	 *
	 * @param {String} name
	 * @param {Boolean} state
	 */
	function setError(name, state) {
		if (name && typeof state !== 'undefined') {
			templateData.errors[name] = state;
		}
	}

	/**
	 * resetErrors
	 */
	function resetErrors() {
		templateData.errors = {};
		renderData();
	}

	/**
	 * Get C&P campaigns that are currently active or will be active within a day.
	 * @returns {Object[]} An array of campaign objects.
	 */
	async function getCNPCampaigns() {
		return await fetch('/stage-ajax/getCNPCampaigns').then(response => response.json()).then(data => data.map(campaign => ({
			...campaign,
			start: new Date(campaign.start),
			end: new Date(campaign.end),
		})));
	}

	/**
	 * Check if a campaign is valid for the current product.
	 * @param {Object} campaign - The campaign object as returned by getCNPCampaigns.
	 * @param {Object} product - The product object, including properties category_type, category, subcategory, brand, campaignIds.
	 * @returns {Boolean} True if the campaign is valid for the product, false otherwise.
	 */
	function campaignIsValidForProduct(campaign, product) {
		if (!product || !campaign) return false;

		// Check if the campaign is active at the moment
		const now = new Date();
		if (
			!isValidDateObject(campaign.start) || now < campaign.start || // campaign has not yet started, or start date missing/invalid
			!isValidDateObject(campaign.end) || now > campaign.end // campaign has already ended, or end date missing/invalid
		) {
			return false;
		}

		// Check that category type of the campaign matches the product's type (clothing, shoe, accessory)
		if (campaign.saleCategoryTypes.length > 0 && !campaign.saleCategoryTypes.includes(product.categoryType)) {
			return false;
		}

		// Check that product category of the campaign matches the product's category
		if (campaign.saleCategories.length > 0 && !campaign.saleCategories.includes(product.category)) {
			return false;
		}

		// Check that product subcategory of the campaign matches the product's subcategory
		if (campaign.saleSubCategories.length > 0 && !campaign.saleSubCategories.includes(product.subcategory)) {
			return false;
		}

		// Check that brand of the campaign matches the product's brand
		if (campaign.saleBrands.length > 0 && !campaign.saleBrands.includes(product.brandName)) {
			return false;
		}

		// Check that product campaign id of the campaign matches the product's campaign id
		if (campaign.saleCampaignIds.length > 0 && !isValidSaleCampaignProduct(campaign.saleCampaignIds, product.campaignIds)) {
			return false;
		}


		if ((campaign.campaignType === 'fromNormalPrice')) {

			if (!((product.retailPrice > 0) && (templateData?.reservation?.items?.[0]?.price > 0))) {
				return false;
			}

			const campaignSaleMultiplier = 1.0 - campaign.salePercentage;
			const activePrice = Number.parseFloat(templateData.reservation.items[0].price);
			const fromRetailPrice = product.retailPrice * campaignSaleMultiplier;

			if (fromRetailPrice > activePrice) {
				return false;
			}
		}

		return true;
	}

	/**
	 * toggleClickAndCollect
	 *
	 * @param {Boolean} show
	 */
	function toggleClickAndCollect(show = true) {
		if (show) {
			$clickAndCollect.one(utils.transitionDone(), function () {
				$clickAndCollect.addClass('transition-done');
			});
		} else {
			$clickAndCollect.removeClass('transition-done');
		}

		$html.toggleClass('v4-product-click-and-collect-open', show);
	}

	function deliveryFee() {
		const hasCustomShipmentTypes = customShipmentTypes.length ? true : false;

		templateData.reservation.hasCustomDelivery = hasCustomShipmentTypes;
		templateData.reservation.customDelivery = false;
		if (hasCustomShipmentTypes) {
			templateData.reservation.customDelivery = customShipmentTypes.map(
				(shipment) => {
					return {
						id: shipment.id,
						name: shipment.name,
						currentPrice: (userInfo && parseInt(userInfo.activated) === 1) ? parseFloat(shipment.club).toFixed(2) : parseFloat(shipment.default).toFixed(2),
						priceClub: parseFloat(shipment.club).toFixed(2),
						priceDefault: parseFloat(shipment.default).toFixed(2)
					};
				});
		}


		if (userInfo && parseInt(userInfo.activated) === 1) {
			templateData.reservation.deliveryFee = templateData.reservation
				.specialDelivery
				? '24.9'
				: '5.90';
			templateData.reservation.shipmentFee = {
				posti: parseFloat(shipmentTypes.posti.club).toFixed(2),
				kotiintoimitus: parseFloat(shipmentTypes.kotiintoimitus.club).toFixed(
					2
				),
				special: parseFloat(shipmentTypes.special.club).toFixed(2),
			};

			if (hasCustomShipmentTypes) {
				let cheapestDeliveryFee = false;
				for (const shipment of customShipmentTypes) {
					templateData.reservation.shipmentFee[shipment.id] = parseFloat(shipment.club).toFixed(2);
					if (!cheapestDeliveryFee || (shipment.club < cheapestDeliveryFee)) {
						cheapestDeliveryFee = shipment.club;
					}
				}
				if (cheapestDeliveryFee) {
					templateData.reservation.deliveryFee = cheapestDeliveryFee;
				}
			}

			// Check for free delivery
			if (templateData.reservation && templateData.reservation.items) {
				if (
					templateData.reservation.items[0].price > 50 &&
					userInfo.level &&
					userInfo.level === 'gold'
					&& !hasCustomShipmentTypes
				) {
					if (!templateData.reservation.specialDelivery) {
						templateData.reservation.deliveryFee = '0.00';
					}
					templateData.reservation.shipmentFee.posti = parseFloat(0).toFixed(2);
				}
			}
		} else {
			templateData.reservation.deliveryFee = templateData.reservation
				.specialDelivery
				? '49.9'
				: '7.90';
			templateData.reservation.shipmentFee = {
				posti: parseFloat(shipmentTypes.posti.default).toFixed(2),
				kotiintoimitus: parseFloat(
					shipmentTypes.kotiintoimitus.default
				).toFixed(2),
				special: parseFloat(shipmentTypes.special.default).toFixed(2),
			};

			if (hasCustomShipmentTypes) {
				let cheapestDeliveryFee = false;

				for (const shipment of customShipmentTypes) {
					templateData.reservation.shipmentFee[shipment.id] = parseFloat(shipment.default).toFixed(2);
					if (!cheapestDeliveryFee || (shipment.default < cheapestDeliveryFee)) {
						cheapestDeliveryFee = shipment.default;
					}
				}
				if (cheapestDeliveryFee) {
					templateData.reservation.deliveryFee = cheapestDeliveryFee;
				}

			}
		}
	}

	/**
	 * renderData
	 */
	function renderData() {
		filterStoresbyCity();
		orderStoresByLocation();
		deliveryFee();

		$('#click-and-collect-content').html(
			Mustache.render(template, templateData)
		);
		const $reservationForm = $('.click-and-collect-reservation-form');
		if ($reservationForm.length) {
			inputFilteringEvents($reservationForm);
		}
		$('.prepayment-description').on('click', (e) => {
			e.preventDefault();
			$('#prepayment-description').toggleClass('hidden');
		});

		if (!userInfo) {
			if (hasActiveClickAndCollectSale) {
				$('.cc-info-box.sale-login').removeClass('hidden');
			} else {
				$('.cc-info-box.club-login').removeClass('hidden');
			}
		} else {
			$('.show-for-online-payment').removeClass('hidden');
		}

		$('.cc-info-box.plussa-campaign-info').toggleClass('hidden', true);
		$('.cc-info-box.sale-login').toggleClass('hidden', true);
		$('.cc-info-box.brand-sale-info').toggleClass('hidden', true);
		$('.cc-info-box.from-normal-price-sale-info').toggleClass('hidden', true);
		infoTextAccordion();
	}

	/**
	 * storeScrollPosition
	 *
	 * @param {jQuery} $el
	 * @param {Number} [pos]
	 */
	function storeScrollPosition($el, pos = $el.scrollTop()) {
		$el.data('scrollPosition', pos);
	}

	/**
	 * restoreScrollPosition
	 *
	 * @param {jQuery} $el
	 */
	function restoreScrollPosition($el) {
		$el.scrollTop($el.data('scrollPosition'));

		$el.data('scrollPosition', 0);
	}

	/**
	 * Fetch new token for the form and auto submit it
	 *
	 * @param {jQuery} $form
	 */
	function updateFormToken($form) {
		const $fields = $('input[name$="token"]').val('');

		return getToken().then(function (response) {
			$fields.val(response);
			$('input[name="stage_token"]').val(response);
			if ($form) {
				$form.trigger('submit');
			}
		});
	}

	/**
	 * getTimestamp
	 *
	 * @return {Number}
	 */
	function getTimestamp() {
		return Math.floor(Date.now() / 1000);
	}

	/**
	 * calculateDistance
	 *
	 * @param {Number} lat1
	 * @param {Number} lon1
	 * @param {Number} lat2
	 * @param {Number} lon2
	 *
	 * @return {Number}
	 */
	function calculateDistance(lat1, lon1, lat2, lon2) {
		const toRad = (val) => {
			return val * Math.PI / 180;
		};
		const R = 6371; // km
		const dLat = toRad(lat2 - lat1);
		const dLon = toRad(lon2 - lon1);

		lat1 = toRad(lat1);
		lat2 = toRad(lat2);

		const a =
			Math.sin(dLat / 2) * Math.sin(dLat / 2) +
			Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
		const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
		const d = R * c; //calculate distance between lat/lon
		return d;
	}

	/**
	 * formatPrice
	 *
	 * @param {Number|String}  price
	 * @param {Boolean} [appendEuro]
	 *
	 * @return {String}
	 */
	function formatPrice(price, appendEuro = true) {
		let formattedPrice = '';

		try {
			formattedPrice =
				parseFloat(price)
					.toFixed(2)
					.replace('.', ',')
					.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ') + (appendEuro ? ' €' : '');
		} catch (e) {
			formattedPrice = price;
		}

		return formattedPrice;
	}
}
